import { render } from "./GeneralContactForm.vue?vue&type=template&id=68082094"
import script from "./GeneralContactForm.vue?vue&type=script&lang=js"
export * from "./GeneralContactForm.vue?vue&type=script&lang=js"

import "./GeneralContactForm.vue?vue&type=style&index=0&id=68082094&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__